import { useEffect, useContext, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  AmplitudeContext,
  AmplitudeProvider,
} from '@homebot/shared-util-quartermaster'

import { selectAuthedAsClient } from '../store/selectors/auth'
import {
  selectClientId,
  selectIsHomeowner,
  selectClientIsBuyer,
  selectClientIsGuest,
} from '../store/selectors/client'
import {
  selectCustomerIsRealEstateAgent,
  selectCustomerIsLoanOfficer,
  selectCustomerIsInsuranceAgent,
} from '../store/selectors/customerProfile'
import {
  selectCorporateProfileId,
  selectCustomerId,
} from '../store/selectors/customerProfile'
import { getBearerToken } from '../auth'

const amplitudeClientsDeploymentKey = process.env.REACT_APP_AMPLITUDE_DEPLOYMENT

export const AmpliProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState<object | undefined>()
  const ampliContext = useContext(AmplitudeContext)

  const clientId = useSelector(selectClientId)
  const customerId = useSelector(selectCustomerId)
  const corpId = useSelector(selectCorporateProfileId)

  const isClient = useSelector(selectAuthedAsClient)

  const isLoanOfficer = useSelector(selectCustomerIsLoanOfficer) && !isClient
  const isRealEstateAgent =
    useSelector(selectCustomerIsRealEstateAgent) && !isClient
  const isInsuranceAgent =
    useSelector(selectCustomerIsInsuranceAgent) && !isClient
  const isHomeowner = useSelector(selectIsHomeowner) && isClient
  const isBuyer = useSelector(selectClientIsBuyer) && isClient
  const isGuest = useSelector(selectClientIsGuest) && isClient

  useEffect(() => {
    if (!userDetails && clientId && customerId && corpId) {
      setUserDetails({
        client_id: clientId,
        customer_id: customerId,
        corp_id: corpId,
        is_loan_officer: isLoanOfficer,
        is_insurance_agent: isInsuranceAgent,
        is_real_estate_agent: isRealEstateAgent,
        is_homeowner: isHomeowner,
        is_buyer: isBuyer,
        is_guest: isGuest,
      })
    }
  }, [
    ampliContext,
    clientId,
    corpId,
    customerId,
    isInsuranceAgent,
    isLoanOfficer,
    isRealEstateAgent,
    userDetails,
    isHomeowner,
    isBuyer,
    isGuest,
  ])

  return (
    <AmplitudeProvider
      deploymentKey={amplitudeClientsDeploymentKey}
      token={getBearerToken()}
      appSpecificUserDetails={userDetails}
    >
      {children}
    </AmplitudeProvider>
  )
}
